import { Box, Pressable, Text } from "native-base";
import * as React from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { actResult, slResult } from "../../store/features/resultSlice";
import { API, Reaction, ReactionView } from "../../api/types";
import Colors from "../../const/Colors";
import { Image } from "react-native";
import {
  ic_dislike_notint,
  ic_dislike_tint,
  ic_like_notint,
  ic_like_tint,
} from "../../assets";

interface AdvicesProps {
  type?: string;
}

const AdvicesView = ({ type }: AdvicesProps) => {
  //=========== HOOK ==========
  const { t } = useTranslation();
  const { advices } = useAppSelector(slResult);
  const d = useAppDispatch();

  const [items, setItems] = useState<
    API.ReadAdvicesRecordResponse[] | undefined
  >(undefined);

  useEffect(() => {
    switch (type) {
      case "got":
        setItems(advices?.got);
        break;
      case "ldl":
        setItems(advices?.ldl);
        break;
      case "sbp":
        setItems(advices?.sbp);
        break;
      case "hba1c":
        setItems(advices?.hba1c);
        break;
      case "scr":
        setItems(advices?.scr);
        break;
      case "tg":
        setItems(advices?.tg);
        break;
      case "hdl":
        setItems(advices?.hdl);
        break;
      case "rgtp":
        setItems(advices?.rgtp);
        break;
      case "dbp":
        setItems(advices?.dbp);
        break;
      default:
        break;
    }
  }, [advices]);

  const onPressReaction = (
    viewType: ReactionView,
    record: API.ReadAdvicesRecordResponse
  ) => {
    const currentReaction = record.reactions;
    let newReaction: number | undefined = undefined;

    if (viewType === ReactionView.LIKE) {
      if (currentReaction === Reaction.LIKE) {
        newReaction = Reaction.UNKNOWN;
      } else if (currentReaction === Reaction.DISLIKE) {
        newReaction = Reaction.LIKE;
      } else {
        newReaction = Reaction.LIKE;
      }
    } else if (viewType === ReactionView.DISLIKE) {
      if (currentReaction === Reaction.LIKE) {
        newReaction = Reaction.DISLIKE;
      } else if (currentReaction === Reaction.DISLIKE) {
        newReaction = Reaction.UNKNOWN;
      } else {
        newReaction = Reaction.DISLIKE;
      }
    }

    const isCanChangeReactionByApi = record.status;
    if (newReaction !== undefined && isCanChangeReactionByApi) {
      const req: API.CreateReactionRequest = {
        reactions: newReaction,
        toshiba_advice_id: record.toshiba_advice_id,
      };
      d(actResult.createReaction(req));
    }
  };

  //=========== OUT ==========
  return (
    <Box
      id={"AdviceView"}
      w={"100%"}
      display={"flex"}
      flexDirection={"column"}
      paddingX={"16px"}
      // backgroundColor={'purple.200'}
    >
      {items?.map((value, index) => {
        const currentReaction: number = value.reactions;
        return (
          <Box
            key={index}
            display={"flex"}
            w={"100%"}
            // backgroundColor={'yellow.50'}
          >
            <Text
              id={"adviceT"}
              w={"100%"}
              display={"flex"}
              fontSize={16}
              paddingTop={"16px"}
              justifyContent={"center"}
              alignItems={"center"}
              textAlign={"left"}
              color={Colors.black}
            >
              {value.advice ?? ""}
            </Text>
            <Box
              key={index}
              display={"flex"}
              flexDirection={"row"}
              w={"100%"}
              paddingTop={"8px"}
              alignItems={"center"}
              justifyContent={"end"}
              // backgroundColor={"yellow.50"}
            >
              <Pressable
                onPress={() => onPressReaction(ReactionView.LIKE, value)}
              >
                <Image
                  id={"Like"}
                  style={{
                    width: 32,
                    height: 32,
                  }}
                  source={
                    currentReaction === Reaction.LIKE
                      ? ic_like_tint
                      : ic_like_notint
                  }
                />
              </Pressable>
              <Pressable
                onPress={() => onPressReaction(ReactionView.DISLIKE, value)}
                marginLeft={"24px"}
              >
                <Image
                  id={"Dislike"}
                  style={{
                    width: 32,
                    height: 32,
                  }}
                  source={
                    currentReaction === Reaction.DISLIKE
                      ? ic_dislike_tint
                      : ic_dislike_notint
                  }
                />
              </Pressable>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default AdvicesView;
